import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import HiringPacketPage from './pages/HiringPacketPage';
import NotFoundPage from './pages/NotFoundPage';
import TICA from './pages/TICA';

function App() {
  useEffect(() => {
    document.documentElement.classList.add('bg-slate-100');

    return () => {
      document.documentElement.classList.remove('bg-slate-100');
    };
  }, []);

  return (
    <Routes>
      <Route path='/' element={<HiringPacketPage />} />
      <Route path='/tica' element={<TICA />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
